import { render } from "./TableSetting2.vue?vue&type=template&id=f702f728&scoped=true"
import script from "./TableSetting2.vue?vue&type=script&lang=js"
export * from "./TableSetting2.vue?vue&type=script&lang=js"

import "./TableSetting2.vue?vue&type=style&index=0&id=f702f728&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f702f728"]])

export default __exports__